import {faHome, faInbox} from "@fortawesome/free-solid-svg-icons";

export const DrawerData = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: faHome,
        cName: 'dashboard'
    },
    {
        title: 'Pengajuan',
        path: '/approval',
        icon: faInbox,
        cName: 'approval'
    },
    // {
    //     title: 'Broadcast',
    //     path: '/broadcast',
    //     icon: faBullhorn,
    //     cName: 'broadcast'
    // },
];
